import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Popup from './Popup';
import s from './Popup.css';
import Messages from './Messages';

function SimpleNotificationPopup(props) {
  const messages = Messages();
  const { title, message } = props;
  return (
    <Popup
      className={s.Popup__notification}
      onClose={props.onClose}
      overrideOnClose
    >
      <ul className={s.Popup_tab}>
        <li className={s.is_selected}>
          <FormattedMessage {...messages[title]} />
        </li>
      </ul>
      <p className={s.Popup_body}>
        <FormattedMessage {...messages[message]}  />
      </p>
    </Popup>
  );
}

SimpleNotificationPopup.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(s)(SimpleNotificationPopup);


// WEBPACK FOOTER //
// ./src/components/Popup/SimpleNotificationPopup.js